import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography} from 'views/components';
import {Translate} from 'views/module';
import BiographyQuestion from '../../BiographyQuestion';

const ContentView = (props) => {
  const {bioQuestion, getSignedFileUrl} = props;

  const {bioQuestionId, questionData: {value, schema}} = bioQuestion;

  return (
    <Stack sx={{'borderRadius': '4px'}} gap={2} >
      {
        value.map((question, idx) => (
          <Stack key={idx} >
            <Typography fontWeight='bold'>
              <Translate expression={`caregiver.CaregiverDetail.Biography.Questions.Titles.${bioQuestionId}`} /> {idx+1}:
            </Typography>
            {
              Object.entries(schema).map(([fieldKey, fieldType]) => {
                const pseudoQuestion = {
                  bioQuestionId: `${bioQuestionId}_${fieldKey}`,
                  fieldType,
                  questionData: question[fieldKey],
                };
                return (
                  <BiographyQuestion
                    key={fieldKey}
                    mode='VIEW'
                    bioQuestion={pseudoQuestion}
                    updateQuestionData={() => undefined}
                    caregiverBackend={{bioQuestions: {getSignedFileUrl}, detail: {editPhotoUrl: () => undefined}}}
                    subQuestion
                  />
                );
              })
            }
          </Stack>
        ))
      }

    </Stack>
  );
};

ContentView.propTypes = {
  bioQuestion: PropTypes.shape({
    bioQuestionId: PropTypes.string.isRequired,
    questionData: PropTypes.shape({
      value: PropTypes.array.isRequired,
      schema: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,
  getSignedFileUrl: PropTypes.func,
};

export default ContentView;
